export default "__VITE_ASSET__DkklS0h4__"